export enum UserPreferenceType {
  // OLIO-3318 renames the api's UserPreference::Notification record to
  // UserPreference::Notification::CareCoordination, and the wire `type` identifier follows the
  // class path (slash-path form below; milestone 2 adds 'notification/inbound_referrals' as its
  // sibling). This dual-accept simply DEPLOYS BEFORE the api's rename, so every session
  // understands the new string before anything emits it — the 15-minute inactivity logout
  // recycles sessions fast enough that no further coordination is needed. Once the api's flip
  // is out, drop this legacy member and make the slash-path the default (an OLIO-3323 scope
  // item — see that ticket and OLIO-3318 for the full choreography).
  NOTIFICATION = 'notification',
  NOTIFICATION_CARE_COORDINATION = 'notification/care_coordination',
  INSIGHTS_FILTER = 'insights_filter',
  PORTFOLIO_FILTER = 'portfolio_filter',
  DISCHARGE_CALENDAR_FILTER = 'discharge_calendar_filter',
}

export interface UserPreferenceOptions {
  id: string;
  clientId: string;
  type: UserPreferenceType;
  // Models inheriting from this class should define the shape of `value`
  value: Record<string, any>;
}

export function getDefaults(): UserPreferenceOptions {
  return {
    id: '',
    clientId: '',
    type: UserPreferenceType.PORTFOLIO_FILTER,
    value: {},
  };
}

export default class UserPreference {
  id: string;
  clientId: string;
  type: UserPreferenceType;
  // Models inherting from this class should define the shape of `value`
  value: Record<string, any>;

  constructor(options: Partial<UserPreferenceOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    this.id = opts.id;
    this.clientId = opts.clientId;
    this.type = opts.type;
    this.value = opts.value;
  }
}
